const defaultImages = [
  {
    id: 'DatoCmsPageImage-149218013',
    name: 'equipment-panel',
    image: {
      alt: 'Cove hub and display',
      url: 'https://www.datocms-assets.com/10154/1723830447-group-365.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218014',
    name: 'cove-connect-app',
    image: {
      alt: 'Cove Connect App',
      url: 'https://www.datocms-assets.com/10154/1680206256-cove-connect-app.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218015',
    name: 'motion-sensor',
    image: {
      alt: 'motion_detector',
      url: 'https://www.datocms-assets.com/10154/1657571096-motion_detector_gen2.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218016',
    name: 'camera',
    image: {
      alt: 'Eufy outdoor camera icon',
      url: 'https://www.datocms-assets.com/10154/1723828975-eufy_outdoor_angle_on.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149219047',
    name: 'smoke-detector',
    image: {
      alt: 'smoke detector',
      url: 'https://www.datocms-assets.com/10154/1687192615-smoke-detector-temp-3.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218017',
    name: 'medical-button',
    image: {
      alt: 'medical-button',
      url: 'https://www.datocms-assets.com/10154/1657572003-medical_button.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218018',
    name: 'hover-smoke',
    image: {
      alt: 'Cove Smoke Detectore',
      url: 'https://www.datocms-assets.com/10154/1723829458-smokedetector_topview_01-1.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218019',
    name: 'hover-app-new',
    image: {
      alt: 'Cove Connect App',
      url: 'https://www.datocms-assets.com/10154/1723829315-group-363.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218020',
    name: 'hover-siren',
    image: {
      alt: 'alula cove siren',
      url: 'https://www.datocms-assets.com/10154/1682959154-alula-cove-siren.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218021',
    name: 'hover-skybell',
    image: {
      alt: 'Skybell Doorbell Camera',
      url: 'https://www.datocms-assets.com/10154/1680214664-doorbell-camera_skybell_silver.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218022',
    name: 'hover-co',
    image: {
      alt: 'Cove Carbon Monoxide Detector',
      url: 'https://www.datocms-assets.com/10154/1723828184-co-detector.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218023',
    name: 'hover-hub-new',
    image: {
      alt: 'Alula security hub',
      url: 'https://www.datocms-assets.com/10154/1723828054-hub_no-shadow.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218024',
    name: 'hover-display',
    image: {
      alt: 'Alula display',
      url: 'https://www.datocms-assets.com/10154/1723829978-render.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218025',
    name: 'hover-door',
    image: {
      alt: 'Cove Door/Window Sensor',
      url: 'https://www.datocms-assets.com/10154/1680214831-door-window-sensor.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218026',
    name: 'hover-camera',
    image: {
      alt: 'Cove Indoor Camera',
      url: 'https://www.datocms-assets.com/10154/1680214859-front.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218027',
    name: 'hover-medical',
    image: {
      alt: 'Cove Medical Button',
      url: 'https://www.datocms-assets.com/10154/1680214888-medical-button.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218028',
    name: 'hover-motion',
    image: {
      alt: 'Cove Motion Detector',
      url: 'https://www.datocms-assets.com/10154/1680214916-motion-detector.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218029',
    name: 'hover-flood',
    image: {
      alt: 'Cove Flood Sensor',
      url: 'https://www.datocms-assets.com/10154/1680214951-flood-sensor.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218030',
    name: 'hover-remote',
    image: {
      alt: 'Cove Keyfob remote',
      url: 'https://www.datocms-assets.com/10154/1680214974-key-remote.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218031',
    name: 'hover-glass-break',
    image: {
      alt: 'Cove Glass Break Sensor',
      url: 'https://www.datocms-assets.com/10154/1680215000-glass-break-sensor.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218032',
    name: 'hover-outdoor',
    image: {
      alt: 'Eufy outdoor camera',
      url: 'https://www.datocms-assets.com/10154/1723828975-eufy_outdoor_angle_on.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218033',
    name: 'hover-doorbell',
    image: {
      alt: 'Eufy Doorbell camera and chime',
      url: 'https://www.datocms-assets.com/10154/1687188884-eufy-doorbell-camera.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-1492180332',
    name: 'hover-doorbell-camera',
    image: {
      alt: 'Eufy Doorbell camera',
      url: 'https://www.datocms-assets.com/10154/1723828816-eufydoorbell.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-1492180333',
    name: 'hover-doorbell-chime',
    image: {
      alt: 'Eufy Doorbell chime',
      url: 'https://www.datocms-assets.com/10154/1723828835-eufy_chime.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218034',
    name: 'hover-eufy-indoor',
    image: {
      alt: 'eufy indoor camera',
      url: 'https://www.datocms-assets.com/10154/1686083863-eufy_indoor_mini_on.png?auto=format',
    },
  },
  {
    id: 'DatoCmsPageImage-149218330',
    name: 'hover-smoke-new',
    image: {
      alt: 'Cove Smoke Detector',
      url: 'https://www.datocms-assets.com/10154/1687188808-smoke-detector-temp-2.png?auto=format',
    },
  },
];

export default defaultImages;
